import { render, staticRenderFns } from "./ScoreboardWithPoint.vue?vue&type=template&id=26205896"
import script from "./ScoreboardWithPoint.vue?vue&type=script&lang=js"
export * from "./ScoreboardWithPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports